import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { AuditList } from '../components/AuditList';
import { ErrorText } from '../components/ui';

export function AuditPage() {
  const audit = useQuery({ queryKey: ['audit'], queryFn: api.audit });
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Jurnal</h1>
      <p className="text-sm text-slate-400">
        Ultimele 300 de acțiuni din consolă: cine a pornit sau oprit accesul, facturi, chei.
      </p>
      <ErrorText error={audit.error} />
      <AuditList entries={audit.data ?? []} showTenant />
    </div>
  );
}
